'use client';

import * as DialogPrimitive from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import { cx } from '../../utils/cx';
import styles from './Dialog.module.css';

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;

export interface DialogContentProps extends Omit<
  DialogPrimitive.DialogContentProps,
  'title'
> {
  title: ReactNode;
  description?: ReactNode;
  showClose?: boolean;
}

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  (
    { title, description, showClose = true, className, children, ...props },
    ref
  ) => (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className={styles.overlay} />
      <DialogPrimitive.Content
        ref={ref}
        className={cx(styles.content, className)}
        {...props}
      >
        <DialogPrimitive.Title className={styles.title}>
          {title}
        </DialogPrimitive.Title>
        {description && (
          <DialogPrimitive.Description className={styles.description}>
            {description}
          </DialogPrimitive.Description>
        )}

        {children}

        {showClose && (
          <DialogPrimitive.Close className={styles.close} aria-label="Close">
            ×
          </DialogPrimitive.Close>
        )}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  )
);

DialogContent.displayName = 'DialogContent';
